/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Pre_Replace_Dialog_SaveInputs */



/**
* | output |
* | --- |
* | "Pre-replace ({n})" |
*
* @param {Pre_Replace_Dialog_SaveInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const pre_replace_dialog_save = /** @type {((inputs: Pre_Replace_Dialog_SaveInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pre_Replace_Dialog_SaveInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Pre-replace (${i?.n})`)
	return /** @type {LocalizedString} */ (`Pré-remplacer (${i?.n})`)
});